<template>

    <AjanlatBase :titleExtra="titleExtra"  v-if="facebookVisible() || husegkartyaVisible() || podkSorszamVisible()">

        <v-form slot="biztositoi-adatok" ref="ajanlat-adatok">

            <v-layout row wrap>

                <BnFormField v-if="facebookVisible()" :attributes="posta_facebook_kod" />

                <BnFormField v-if="husegkartyaVisible()" :attributes="posta_vonalkod" />

                <BnFormField v-if="husegkartyaVisible()" :attributes="posta_kartyaszam" />

                <BnFormField v-if="podkSorszamVisible()" :attributes="podk_sorszam" />

            </v-layout>

        </v-form>

    </AjanlatBase>

</template>

<script>
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import AjanlatBase from '../KGFBAjanlatBase.vue';
import offerData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/OfferData';

export default {
    name: 'AjanlatAdatokB9_V0',
    components: { AjanlatBase, BnFormField },
    mixins: [offerData],
    methods: {
        facebookVisible() {
            return this.kedvezmenyek.facebook === true;
        },
        husegkartyaVisible() {
            return this.kedvezmenyek.huseg === true;
        },
        podkSorszamVisible() {
            return this.kedvezmenyek.podk === true;
        },
    },
    data() {
        return {
            posta_facebook_kod: {
                type: 'text',
                label: 'Facebook kupon kód',
                visible: true,
                editable: true,
                help: true,
                mezo: 'posta_facebook_kod',
                path: 'tarifaData.posta_facebook_kod',
            },
            posta_vonalkod: {
                type: 'text',
                label: 'Posta hűségkártya vonalkód azonosító',
                visible: true,
                editable: true,
                help: true,
                mezo: 'posta_vonalkod',
                path: 'tarifaData.posta_vonalkod',
            },
            posta_kartyaszam: {
                type: 'text',
                label: 'Posta hűségkártya utolsó négy számjegye',
                visible: true,
                editable: true,
                help: true,
                mezo: 'posta_kartyaszam',
                path: 'tarifaData.posta_kartyaszam',
                mask: '####',
            },
            podk_sorszam: {
                type: 'text',
                label: 'Postai folyamatos díjas életbiztosítás kalkuláció sorszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'podk_sorszam',
                path: 'tarifaData.podk_sorszam',
            },
        };
    },
};
</script>
